import { GeolocationPoint, DeviceInfos, DownloadUpdatesInfos, AppInfos, UploadLocalDatabaseInfos, UpdateInfos } from 'src/app/app.models';
import { BehaviorSubject, Subject } from 'rxjs';

export abstract class PlatformService {
    lastKnownLocation = new BehaviorSubject<GeolocationPoint>(null);
    updatesStatus = new BehaviorSubject<{ status: number, progress?: number }>(null);
    uploadLocalDatabaseStatus = new BehaviorSubject<{ status: number, progress?: number }>(null);
    keyboardStatus = new BehaviorSubject(false);
    
    abstract getAppVersion(): Promise<AppInfos>;
    abstract deviceId(): string;
    abstract showNotification(title: string, message: string): void;
    abstract scanQRCode(): Promise<string>;
    abstract takePhoto(): Promise<string>;
    abstract scanDocument(): Promise<string>;
    abstract famocoScanLaser(): Promise<string>;
    abstract getDeviceInfos(): Promise<DeviceInfos>;
    abstract getCurrentLocation(): Promise<GeolocationPoint>;
    abstract printDocument(_filename: string, _html: string, openAfterPrint?: boolean): void;
    abstract startListenLocation(): Promise<void>;
    abstract stopListenLocation(): void;
    abstract downloadUpdates(downloadInfos: DownloadUpdatesInfos): Promise<void>;
    abstract uploadLocalDatabase(uploadLocalDatabaseInfos: UploadLocalDatabaseInfos): Promise<void>;
    abstract installLatestUpdate(updateInfos: UpdateInfos): Promise<void>;

    // BT
    bluetoothDevicesScanned = new Subject<any[]>();
    abstract scanBTDevices();
    abstract connectBTDevice(macAddress: string);
    abstract disconnectBTDevice();
    abstract printBTTicket(template: string, datas: any);
    //

    abstract newlandStartScan(): Promise<string>;

    isAndroidApp() {
        const androidApp = localStorage.getItem('ANDROID_APP');
        const androidId = localStorage.getItem('ANDROID_ID');
        //return !!androidApp && !!androidId;
        return window.location.href.lastIndexOf("https://appassets.androidplatform.net") > -1;
    }
}

export class PlatformResult {
    status: API_RESULT_STATUS;
    datas?: any;
    error?: string;
}

export enum API_RESULT_STATUS {
    ERROR = -1,
    PENDING = 0,
    SUCCESS = 1
}